import { render } from "./set_holiday.vue?vue&type=template&id=0fde2f86&scoped=true"
import script from "./set_holiday.vue?vue&type=script&lang=js"
export * from "./set_holiday.vue?vue&type=script&lang=js"

import "./set_holiday.vue?vue&type=style&index=0&id=0fde2f86&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fde2f86"]])

export default __exports__